'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var React__default = _interopDefault(React);
var classnames = _interopDefault(require('classnames'));
var PropTypes = _interopDefault(require('prop-types'));
var icon_treat = require('../Icons/icon.treat.js');
var Close = require('../Icons/components/Close.js');
var DownChevron = require('../Icons/components/DownChevron.js');
var _Error = require('../Icons/components/Error.js');
var Info = require('../Icons/components/Info.js');
var Success = require('../Icons/components/Success.js');
var UpChevron = require('../Icons/components/UpChevron.js');
var Warning = require('../Icons/components/Warning.js');
var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));
var _inherits = _interopDefault(require('@babel/runtime/helpers/inherits'));
var _possibleConstructorReturn = _interopDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf = _interopDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var srOnly_treat = require('../../util/commonStyles/srOnly.treat.js');
var alert_treat = require('./alert.treat.js');
var ToggleContent = require('../ToggleContent/ToggleContent.js');
var Button = require('../Button/Button.js');

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var ALERT_ICONS = {
  success: /*#__PURE__*/React__default.createElement(Success.default, {
    size: "22px"
  }),
  info: /*#__PURE__*/React__default.createElement(Info.default, {
    size: "22px"
  }),
  warning: /*#__PURE__*/React__default.createElement(Warning.default, {
    size: "22px"
  }),
  danger: /*#__PURE__*/React__default.createElement(_Error.default, {
    size: "22px"
  })
};
/* eslint-disable react/prefer-stateless-function */

/**
 * Alert
 *
 * @visibleName
 */

var Alert = /*#__PURE__*/function (_React$Component) {
  _inherits(Alert, _React$Component);

  var _super = _createSuper(Alert);

  function Alert() {
    _classCallCheck(this, Alert);

    return _super.apply(this, arguments);
  }

  _createClass(Alert, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          type = _this$props.type,
          inline = _this$props.inline,
          children = _this$props.children,
          onDismiss = _this$props.onDismiss,
          secondaryMessage = _this$props.secondaryMessage,
          secondaryMessageVisible = _this$props.secondaryMessageVisible,
          className = _this$props.className;
      var dismissAfter = this.props.dismissAfter;
      var classNames = classnames("alert-flex alert alert-".concat(type), alert_treat.Alert.base, alert_treat.AlertTypes[type], (_classnames = {
        'alert-inline': inline
      }, _defineProperty(_classnames, alert_treat.AlertInline.base, inline), _defineProperty(_classnames, alert_treat.Alert.whenInlineFalse, !inline), _classnames), className);

      if (type === 'success' && dismissAfter === undefined) {
        dismissAfter = 5000;
      }

      if (onDismiss && dismissAfter) {
        setTimeout(onDismiss, dismissAfter);
      }

      var _renderContent = /*#__PURE__*/React__default.createElement("div", {
        className: classnames('alert-msg', alert_treat.Alert.message)
      }, children);

      var renderWithToggle = /*#__PURE__*/React__default.createElement(ToggleContent.default, {
        className: classnames('alert-toggle', alert_treat.Alert.toggle),
        visible: secondaryMessageVisible,
        renderContent: function renderContent(_ref) {
          var show = _ref.show,
              toggle = _ref.toggle;
          return /*#__PURE__*/React__default.createElement("div", {
            className: classnames('alert-toggle-msg', alert_treat.Alert.toggleMessage)
          }, _renderContent, /*#__PURE__*/React__default.createElement(Button.Button, {
            onClick: toggle,
            type: "clear",
            size: "xs",
            className: classnames('alert-btn', alert_treat.Alert.button)
          }, show ? /*#__PURE__*/React__default.createElement(UpChevron.default, null) : /*#__PURE__*/React__default.createElement(DownChevron.default, null), /*#__PURE__*/React__default.createElement("span", {
            className: classnames('sr-only', srOnly_treat.srOnly)
          }, show ? 'Hide' : 'Show', " more information")));
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classnames('alert-msg alert-msg--secondary', alert_treat.Alert.message, alert_treat.Alert.messageSecondary)
      }, secondaryMessage));
      return /*#__PURE__*/React__default.createElement("div", {
        role: "alert",
        className: classNames
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classnames('alert-icon', alert_treat.Alert.icon, icon_treat.overrides["alert-".concat(type)])
      }, ALERT_ICONS[type]), secondaryMessage ? renderWithToggle : _renderContent, onDismiss && /*#__PURE__*/React__default.createElement(Button.Button, {
        onClick: onDismiss,
        type: "clear",
        size: "xs",
        className: classnames('alert-btn alert-btn--close', alert_treat.Alert.button)
      }, /*#__PURE__*/React__default.createElement(Close.default, {
        size: "14px",
        className: alert_treat.Alert.closeIcon
      }), /*#__PURE__*/React__default.createElement("span", {
        className: classnames('sr-only', srOnly_treat.srOnly)
      }, "Close")));
    }
  }]);

  return Alert;
}(React__default.Component);

_defineProperty(Alert, "defaultProps", {
  type: 'success',
  inline: undefined,
  children: undefined,
  onDismiss: undefined,
  dismissAfter: undefined,
  secondaryMessage: undefined,
  secondaryMessageVisible: false,
  className: undefined
});

process.env.NODE_ENV !== "production" ? Alert.propTypes = {
  /**
   * Type of alert being used.
   *
   * - `success`: Green - Successful action has taken place.
   *
   * - `info`: Blue - Information for the user.
   *
   * - `warning`: Yellow - Alert the user of a potential/non blocking issue.
   *
   * - `danger`: Red - Error message - something broke.
   *
   */
  type: PropTypes.oneOf(alert_treat.AlertTypeEnums),

  /**
   * add "inline" change the style to "alert-inline"
   */
  inline: PropTypes.bool,

  /**
   * One or many nodes to be rendered. Traditionally the string of the alert, but this has been left open incase of unforseen circumstances.
   */
  children: PropTypes.node,

  /**
   * callback fired after click on the close button or after the dismissAfter delay
   */
  onDismiss: PropTypes.func,

  /**
   * a millisecond delay before calling the onDismiss callback. If type is success then default is 5000
   */
  dismissAfter: PropTypes.number,

  /**
   * Nodes to appear inside a show/hide toggle.
   * If true adds a Chevron icon in the top right to show/hide the nodes.
   * secondaryMessage nodes are hidden on render.
   */
  secondaryMessage: PropTypes.node,

  /**
   * If true the secondaryMessage nodes will be visible on render
   */
  secondaryMessageVisible: PropTypes.bool,

  /**
   * Specify your own classname into this prop, if you need to customise layout of this component.
   * This classname will be put into the parent container of this components
   * @since Version 6.0.0
   */
  className: PropTypes.string
} : void 0;

exports.ALERT_ICONS = ALERT_ICONS;
exports.default = Alert;
